import { MealTime } from "@/clients/models/MealTime";
import { atom } from "jotai";

export type PlanAdjustmentIntent = {
  kind: "add-meal-to-slot";
  day: string;
  mealTime: MealTime;
  mealId: string;
  mealName?: string;
  targetDate?: string;
  canUndo: boolean;
};

export const planAdjustmentIntentAtom = atom<PlanAdjustmentIntent | null>(null);
